(() => {
  const format = (price) => {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(price / 12, theme.settings.moneyFormat).replace(/<[^>]*>/g, '');
    return new Intl.NumberFormat('es-CL', {style:'currency',currency:'CLP',maximumFractionDigits:0}).format(price / 1200);
  };
  const update = (box, price) => {
    if (!box || !Number.isFinite(Number(price))) return;
    box.hidden = Number(price) <= 0;
    box.dataset.flowAmount = price;
    const value = box.querySelector('strong');
    if (value) value.textContent = format(Number(price));
  };
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-flaw-flow="product"]').forEach(box => {
      if ((box.dataset.flowVariants || '').split(',').includes(String(variant.id))) update(box, variant.price);
    });
  });
  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail && (event.detail.cart || event.detail);
    if (!cart || typeof cart.total_price !== 'number') return;
    document.querySelectorAll('[data-flaw-flow="cart"]').forEach(box => update(box, cart.total_price));
  });
  const syncCart = () => document.querySelectorAll('[data-flaw-flow="cart"]').forEach(box => {
    const form = box.closest('form');
    const items = form && form.querySelector('[data-cart-subtotal]');
    const price = items && Number(items.dataset.cartSubtotal);
    if (items && String(price) !== box.dataset.flowAmount) update(box, price);
  });
  new MutationObserver(syncCart).observe(document.body, {childList:true,subtree:true});
})();
